module.exports = __webpack_public_path__ + "assets/8aa0c401264a6fbb7b0adec9814a30bd.png";